import type { VoxelWorld } from "./VoxelWorld.ts";

interface GridPosition {
  x: number;
  y: number;
  z: number;
}

export function isWalkInteractiveBlock(blockId: string): boolean {
  return (
    blockId.endsWith("_door") ||
    blockId.endsWith("_trapdoor") ||
    blockId.endsWith("_fence_gate")
  );
}

export function toggleWalkInteractiveBlock(
  world: VoxelWorld,
  position: GridPosition
): boolean {
  const block = world.getBlockData(
    position.x,
    position.y,
    position.z
  );
  if (!block || !isWalkInteractiveBlock(block.blockId)) {
    return false;
  }

  const nextOpen = block.state.open === "true"
    ? "false"
    : "true";

  world.runBatch(() => {
    world.setBlock(
      position.x,
      position.y,
      position.z,
      block.blockId,
      {
        ...block.state,
        open: nextOpen
      }
    );

    if (!block.blockId.endsWith("_door")) {
      return;
    }

    const half = block.state.half || "lower";
    const companionY =
      half === "upper" ? position.y - 1 : position.y + 1;
    const companion = world.getBlockData(
      position.x,
      companionY,
      position.z
    );

    if (
      companion &&
      companion.blockId === block.blockId
    ) {
      world.setBlock(
        position.x,
        companionY,
        position.z,
        companion.blockId,
        {
          ...companion.state,
          open: nextOpen
        }
      );
    }
  });

  return true;
}
